export enum CollectionSiteType {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
  INDUSTRIAL = 'INDUSTRIAL',
  PUBLIC = 'PUBLIC'
}

export enum CollectionSiteStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MAINTENANCE = 'MAINTENANCE'
}

export interface CollectionSiteSchema {
  id: string;
  longitude?: number;
  latitude?: number;
  google_maps_url?: string;
  area?: number;
  data: Record<string, any>;
  organization_id?: string;
  status?: string;
  created_at: string;
  updated_at: string;
}

export interface CollectionSiteRequest {
  longitude?: number;
  latitude?: number;
  google_maps_url?: string;
  area?: number;
  data?: Record<string, any>;
  organization_id?: string;
  status?: string;
}

export interface UpdateCollectionSiteRequest {
  longitude?: number;
  latitude?: number;
  google_maps_url?: string;
  area?: number;
  data?: Record<string, any>;
  organization_id?: string;
  status?: string;
}

export interface CollectionSiteQueryParams {
  organization_id: string;
  page?: number;
  limit?: number;
  search?: string;
}

export interface PaginatedCollectionSiteResponse {
  sites: CollectionSiteSchema[];
  total: number;
} 